import { IconProps } from "../../utils/global-types/global-types";

const PlusFilledIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        d="M9.00065 2.33337C5.32732 2.33337 2.33398 5.32671 2.33398 9.00004C2.33398 12.6734 5.32732 15.6667 9.00065 15.6667C12.674 15.6667 15.6673 12.6734 15.6673 9.00004C15.6673 5.32671 12.674 2.33337 9.00065 2.33337ZM11.6673 9.50004H9.50065V11.6667C9.50065 11.94 9.27398 12.1667 9.00065 12.1667C8.72732 12.1667 8.50065 11.94 8.50065 11.6667V9.50004H6.33398C6.06065 9.50004 5.83398 9.27337 5.83398 9.00004C5.83398 8.72671 6.06065 8.50004 6.33398 8.50004H8.50065V6.33337C8.50065 6.06004 8.72732 5.83337 9.00065 5.83337C9.27398 5.83337 9.50065 6.06004 9.50065 6.33337V8.50004H11.6673C11.9407 8.50004 12.1673 8.72671 12.1673 9.00004C12.1673 9.27337 11.9407 9.50004 11.6673 9.50004Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusFilledIcon;
